/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Toc_TitleInputs */

const en_case_toc_title = /** @type {(inputs: Case_Toc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections`)
};

const pt_br2_case_toc_title = /** @type {(inputs: Case_Toc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seções`)
};

/**
* | output |
* | --- |
* | "Sections" |
*
* @param {Case_Toc_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_toc_title = /** @type {((inputs?: Case_Toc_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Toc_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_toc_title(inputs)
	return pt_br2_case_toc_title(inputs)
});